import { IxCard } from './IxCard.js';

window.customElements.define('ix-card', IxCard);
